import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/index.css";

// Set an initial data-theme synchronously BEFORE React mounts so there is no flash of the wrong
// theme. The ThemeProvider then re-resolves against the server-side preference. Default is dark
// per the resolution order (server pref -> prefers-color-scheme -> dark).
const initial =
  window.matchMedia && window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
document.documentElement.setAttribute("data-theme", initial);

createRoot(document.getElementById("root")!).render(<App />);
